import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonBackButton,
  IonContent,
  IonList,
  IonItem,
  IonLabel,
  IonIcon,
  IonSpinner,
  IonText,
} from '@ionic/react';
import { wifiOutline } from 'ionicons/icons';
import { useAdminHubs } from '../../../application/use-cases/admin/useAdminHubs';
import { formatRelative } from '../../../domain/WeatherStation';
import './Admin.css';

const AdminHubs: React.FC = () => {
  const history = useHistory();
  const { hubs, loading, error } = useAdminHubs();

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/app/admin" />
          </IonButtons>
          <IonTitle>Hubs</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        {loading && (
          <div className="ion-text-center ion-padding">
            <IonSpinner color="primary" />
          </div>
        )}
        {error && (
          <IonText color="danger">
            <p className="ion-padding">{error}</p>
          </IonText>
        )}
        {!loading && !error && hubs.length === 0 && (
          <IonText color="medium">
            <p className="ion-padding">Todavía no hay hubs. Se dan de alta en el taller con firmware/tools/taller.py.</p>
          </IonText>
        )}
        <IonList>
          {hubs.map((hub) => (
            <IonItem key={hub.id} button detail onClick={() => history.push(`/app/admin/hubs/${hub.id}`)}>
              <IonIcon icon={wifiOutline} slot="start" color={hub.status === 'online' ? 'success' : 'medium'} />
              <IonLabel>
                <h2>
                  {hub.id} · {hub.status === 'online' ? 'en línea' : 'sin conexión'}
                </h2>
                <p>
                  {hub.ownerEmail ?? 'Stock, sin dueño'}
                  {hub.siteName && ` · ${hub.siteName}`} · {hub.deviceCount} estaciones
                </p>
                <p>
                  {hub.lastSeenAt ? `Último contacto ${formatRelative(hub.lastSeenAt)}` : 'Nunca se conectó'}
                  {hub.lastInfo?.fw && ` · firmware ${hub.lastInfo.fw}`}
                </p>
              </IonLabel>
            </IonItem>
          ))}
        </IonList>
      </IonContent>
    </IonPage>
  );
};

export default AdminHubs;
